import "./App.css";
import Hello from "./Hello";
import Header from "./Header";
import Tweet from "./Tweet";
import Counter from "./Counter";
function App() {
  return (
    <div className="app">
      <Header />
      <Hello />
      <div className="tweets">
        <Tweet author="John" message="Namaste India !!" followers={100} />
        <Tweet author="Jane" message="Hello America !!" followers={110} />
        <Tweet author="Ronald" message="Bonjour France !!" followers={1000} />
        <Tweet author="SpongeB" message="Aloha Hawaii !!" followers={130} />
        {/* Testing default props below */}
        <Tweet />
      </div>
      <div className="counterSection">
        <Counter />
        <Counter />
        <Counter />
      </div>
    </div>
  );
}

export default App;
